import MaterialTable from "material-table";
import { FaTimes } from "react-icons/fa";
const CountDetails = ({ open, closeSampleCsvDialog, data, heading }) => {
  const columns = [
    {
      title: "First Name",
      field: "firstName",
    },
    {
      title: "Last Name",
      field: "lastName",
    },
    {
      title: "Email",
      field: "email",
    },
    {
      title: "Phone Number",
      field: "phoneNumber",
    },
  ];
  return (
    <div>
      {open && (
        <div className="popup-container">
          <div className="popup-container-innner" style={{ width: "1000px" }}>
            <div className="d-flex justify-content-between w-100 brderbtm pad-bottom-10">
              <h6 className="fs-20 semi-bold black"> {heading}</h6>
              <FaTimes
                className="crossview cp"
                onClick={() => closeSampleCsvDialog()}
              />
            </div>
            <MaterialTable
              style={{ textAlign: "center" }}
              title={false}
              columns={columns}
              data={data}
              options={{
                filtering: false,
                headerStyle: {
                  fontFamily: "Rajdhani-Bold",
                  fontSize: 14,
                  backgroundColor: "#F0F8FF",
                },
                rowStyle: { fontSize: 17, fontFamily: "Rajdhani-SemiBold" },
                pageSize: 5,
                pageSizeOptions: [5, 10, 20, 40, 60, 80, 100],
                sorting: true,
                tableLayout: "auto",
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CountDetails;
